<script setup lang="ts">
import FormPatrocinio from '../components/form-patrocinio.vue'
import { usePatrocinioStore } from '../store/usePatrocinioStore'

definePage({
  meta: {
    navActiveLink: 'admin-patrocinio',
    action: 'edit',
    subject: 'patrocinio',
  },
})

const store = usePatrocinioStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormPatrocinio is-editing />
</template>
